import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/revenueCategoriesReducer";
import rootSaga from "./redux/revenueCategoriesSagas";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../../utils/createReduxStore";
import { RevenueCategoriesModule } from "./RevenueCategoriesModule";

const RevenueCategories = (props) => {
  const { notifications, ...rest } = props;

  return (
    <Provider store={createReduxStore(reducer, "revenueCategories", rootSaga)}>
      <ErrorBoundary moduleName="revenueCategories" {...notifications}>
        <RevenueCategoriesModule params={rest} />
      </ErrorBoundary>
    </Provider>
  );
};

export default RevenueCategories;
